import { apiService } from "api/apiService";

/**
 * Send a spoken recording to be transcribed and return the recognised text.
 *
 * The extension follows the blob's own type: Chrome and Firefox record webm,
 * Safari records mp4. The backend validates on the file's actual content, so
 * this only keeps the uploaded part honestly named.
 */
export const createTranscription = async (recording: Blob): Promise<string> => {
  const extension = recording.type.includes("mp4") === true ? "mp4" : "webm";

  const formData = new FormData();
  formData.append("audio", recording, `feedback.${extension}`);

  const { data } = await apiService.post<{ text: string }>(
    "api/catwise-ai/transcribe",
    formData,
  );

  return data.text;
};
